const columns = [
  {
    headerLabel: 'totalAccuracy.dsBranch',
    type: 'general',
    field: 'dsBranch',
    className: 'small-column align-left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'totalAccuracy.dsJanuary',
    type: 'percentage-decimal',
    field: 'dsJanuary',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsFebruary',
    type: 'percentage-decimal',
    field: 'dsFebruary',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsMarch',
    type: 'percentage-decimal',
    field: 'dsMarch',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsApril',
    type: 'percentage-decimal',
    field: 'dsApril',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsMay',
    type: 'percentage-decimal',
    field: 'dsMay',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsJune',
    type: 'percentage-decimal',
    field: 'dsJune',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsJuly',
    type: 'percentage-decimal',
    field: 'dsJuly',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsAugust',
    type: 'percentage-decimal',
    field: 'dsAugust',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsSeptember',
    type: 'percentage-decimal',
    field: 'dsSeptember',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsOctober',
    type: 'percentage-decimal',
    field: 'dsOctober',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsNovember',
    type: 'percentage-decimal',
    field: 'dsNovember',
    className: 'align-center',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'totalAccuracy.dsDecember',
    type: 'percentage-decimal',
    field: 'dsDecember',
    className: 'align-center',
    render: true,
    fixed: false,
  },
]

export default columns
